
import React from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { searchCode } from '../../Helpers';
import { defaultErrorMessage } from '../../Assets/constants';
import { setBookingStep, setCart, setDataByStep, setLoading } from '../../Actions';

function CodeInput(props) {
    const [companyCode, setCompanyCode] = React.useState('');

    const submitCodeAndNext = async () => {
        const { setAlert, setBookingStep, setDataByStep, setLoading } = props;
        if (companyCode) {
            setLoading(true);
            searchCode(companyCode, (response) => {
                let { result, locations, available_dates, data, email_required, payment_required } = response.data;
                setDataByStep(0, { code: companyCode });
                if (!isEmpty(locations)) {
                    setDataByStep(1, { locations });
                    setBookingStep(1);
                } else if (isEmpty(available_dates)) {
                    setAlert("error", "No available dates for this location");
                } else {
                    setDataByStep(1, null);
                    setDataByStep(2, {
                        available_dates,
                        data,
                        email_required,
                        payment_required
                    });
                    setBookingStep(2);
                }
                setLoading(false);
            }, (err) => {
                setLoading(false);
                console.log(err);
                setAlert("error", get(err, 'response.data.message', defaultErrorMessage));
            });
        }
    }
    return (<>
        <div className='contentPrimary font-weight-bold size-44-52 sm-size-28-36 mb-16 sm-mb-8'>
            What's your company code?
        </div>
        <div className='size-18-28 sm-size-16-24 contentPrimary mb-32 sm-mb-40'>
            This helps us validate your employment benefits.
        </div>
        <div className='mb-16 d-flex-only align-items-center justify-content-center'>
            <input
                type="text"
                className="form-control mr-16 generic-input-style-white br-rd-1000 gray-placeholder p-16-20-imp"
                placeholder="Enter your confirmation code"
                onChange={(e) => {
                    setCompanyCode(e.target.value);
                }}
                value={companyCode}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && companyCode) {
                        e.preventDefault();
                        submitCodeAndNext();
                    }
                }}
            />
            <div className='sm-fxd-btm'>
                <button
                    type="button"
                    className="btn md-cta-primary p-16-20-imp"
                    onClick={(e) => {
                        e?.preventDefault();
                        submitCodeAndNext();
                    }}
                    disabled={!companyCode}>
                    Next
                </button>
            </div>
        </div>
    </>);
}
const mapStateToProps = (state) => ({
    ...state.booking,
    loading: state.loading.loading,
});

export default connect(mapStateToProps, {
    setBookingStep, setDataByStep, setCart, setLoading
})(CodeInput);